// https://plasmascan.to/address/0x643441742f73e270e565619be6DE5f4D55E08cd6
export const CROSS_CHAIN_CONTROLLER = '0x643441742f73e270e565619be6DE5f4D55E08cd6';

// IPayloadsControllerCore https://plasmascan.to/address/0xe76EB348E65eF163d85ce282125FF5a7F5712A1d
export const PAYLOADS_CONTROLLER = '0xe76EB348E65eF163d85ce282125FF5a7F5712A1d';

// https://plasmascan.to/address/0xA806DA549FcB2B4912a7dFFE4c1aA7A1ed0Bd5C9
export const PC_DATA_HELPER = '0xA806DA549FcB2B4912a7dFFE4c1aA7A1ed0Bd5C9';

// https://plasmascan.to/address/0x60665b4F4FF7073C5fed2656852dCa271DfE2684
export const GRANULAR_GUARDIAN = '0x60665b4F4FF7073C5fed2656852dCa271DfE2684';

// https://plasmascan.to/address/0x19CE4363FEA478Aa04B9EA2937cc5A2cbcD44be6
export const GOVERNANCE_GUARDIAN = '0x19CE4363FEA478Aa04B9EA2937cc5A2cbcD44be6';

// https://plasmascan.to/address/0xF61FE74Ec1cFbd9Ee8Bd27592D2EDEe0E2aA85Cf
export const CL_EMERGENCY_ORACLE = '0xF61FE74Ec1cFbd9Ee8Bd27592D2EDEe0E2aA85Cf';

// https://plasmascan.to/address/0x47aAdaAE1F05C978E6aBb7568d11B7F6e0FC4d6A
export const EXECUTOR_LVL_1 = '0x47aAdaAE1F05C978E6aBb7568d11B7F6e0FC4d6A';

export const CHAIN_ID = 9745;
